
























































import { Vue, Component, Prop } from "vue-property-decorator";
import { IOrderTemplate } from "@/models/orderTemplates";

@Component({
  components: {
    "order-items-summary": () =>
      import("@/components/app/global/orders/orderItemsSummary.vue")
  }
})
export default class OrderTemplateListItem extends Vue {
  // Props

  @Prop({ default: undefined })
  public orderTemplate?: IOrderTemplate;

  @Prop({ default: false })
  public canUpdate!: boolean;

  @Prop({ default: false })
  public canDelete!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: false })
  public isLoading!: boolean;
}
